export function createRavenToSentryTransportTestkitAdapter(sentryTransport) {
    return (options) => {
        const { sendEvent } = new sentryTransport({});
        void sendEvent(options.data);
        if (options.onSuccess) {
            options.onSuccess();
        }
    };
}
//# sourceMappingURL=createRavenToSentryTransportTestkitAdapter.js.map